module.exports = __webpack_public_path__ + "static/media/karte.141c0678.jpg";